function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onChangeRequirementStatus", "userPermissions"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { branch, compose, mapProps, renderComponent, setPropTypes, withHandlers, withPropsOnChange, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
import lazyLoad from "../../../../util/lazyLoad";
import { getApplicationRequirementsAction, patchApplicationRequirementAction, patchApplicationRequirementReviewStatusAction, patchApplicationRequirementApproveStatusAction, patchApplicationRequirementDisapproveStatusAction } from "../../../../api/jsonapi";
import { applicationCreatingRequirementSelector, applicationEditingRequirementSelector } from "../../../../store/selectors/application";
import { applicationCurrentApplicationSelector, applicationIdSelector } from '@applyboard/ab-common';
import { applicationSetEditRequirementAction, applicationClearEditRequirementAction } from "../../../../store/actions/application";
import { createApplicationRequirementsSelector } from "../../../../store/selectors/requirements";
import initialPropsContextEnhancer from "../../../../components/InitialPropsContext/enhancer";
import handleApiErrorResponse from "../../../../util/handleApiErrorResponse";
import sortRequirementsList, { stageOrder } from "../../../../util/sortRequirementsList";
import displayLoadingState from "../../../../components/LoadingPage/displayLoadingState";
import EmptyState from "./EmptyState";
import { ReloadRequirementsMessage } from "./ReloadRequirementsMessage";
import { camelizeProperties, raiseSuccessMessage } from '@applyboard/ui-utils';
import { isInternalRequirement } from "../../../../data/requirements";
var requirementSort = function requirementSort(a, b) {
  if (!a || !a.title || typeof a.title !== 'string') return -1;
  if (!b || !b.title || typeof b.title !== 'string') return 1;
  return a.title.localeCompare(b.title);
};
function isHiddenRequirement(requirement, userIsAdmin) {
  return requirement.hidden_unless_admin && !userIsAdmin;
}
var enhancer = compose(componentErrorBoundary, connect(createStructuredSelector({
  applicationId: applicationIdSelector,
  application: applicationCurrentApplicationSelector,
  requirementModalVisible: function requirementModalVisible(state) {
    return applicationCreatingRequirementSelector(state) || applicationEditingRequirementSelector(state);
  }
}), function (dispatch) {
  return {
    setEditingRequirement: function setEditingRequirement() {
      return dispatch(applicationSetEditRequirementAction.apply(void 0, arguments));
    },
    closeRequirementModal: function closeRequirementModal() {
      return dispatch(applicationClearEditRequirementAction.apply(void 0, arguments));
    },
    updateApplicationRequirement: function updateApplicationRequirement(application_requirement_id, attributes) {
      dispatch(patchApplicationRequirementAction({
        application_requirement_id: application_requirement_id,
        include: 'attachments,application_questions'
      }, {
        data: {
          attributes: attributes
        }
      })).then(function () {
        return raiseSuccessMessage("Updated requirement ".concat(application_requirement_id));
      })["catch"](function (error) {
        return handleApiErrorResponse(error);
      });
    },
    updateApplicationRequirementReviewStatus: function updateApplicationRequirementReviewStatus(application_requirement_id) {
      return dispatch(patchApplicationRequirementReviewStatusAction({
        application_requirement_id: application_requirement_id
      }, {})).then(function () {
        return raiseSuccessMessage('Status Changed to Reviewing');
      })["catch"](function (error) {
        return handleApiErrorResponse(error);
      });
    },
    updateApplicationRequirementApproveStatus: function updateApplicationRequirementApproveStatus(application_id, application_requirement_id) {
      return dispatch(patchApplicationRequirementApproveStatusAction({
        application_id: application_id,
        application_requirement_id: application_requirement_id,
        include: 'attachments,application_questions'
      }, {})).then(function () {
        return raiseSuccessMessage('Status Changed to Completed');
      })["catch"](function (error) {
        return handleApiErrorResponse(error);
      });
    },
    updateApplicationRequirementDisapproveStatus: function updateApplicationRequirementDisapproveStatus(application_id, application_requirement_id) {
      return dispatch(patchApplicationRequirementDisapproveStatusAction({
        application_id: application_id,
        application_requirement_id: application_requirement_id,
        include: 'attachments,application_questions'
      }, {})).then(function () {
        return raiseSuccessMessage('Status Changed to Not Approved');
      })["catch"](function (error) {
        return handleApiErrorResponse(error);
      });
    }
  };
}), initialPropsContextEnhancer(), withPropsOnChange(['initial_props'], function (_ref) {
  var initial_props = _ref.initial_props;
  return {
    activeStages: initial_props && initial_props.application && initial_props.application.active_stages,
    userPermissions: initial_props && initial_props.permissions || {}
  };
}), branch(function (_ref2) {
  var applicationId = _ref2.applicationId;
  return !applicationId;
}, renderComponent(EmptyState)), lazyLoad('requirementsList', getApplicationRequirementsAction, function (perform, _ref3) {
  var applicationId = _ref3.applicationId;
  return perform({
    include: 'application_additional_attachments,application_external_links,attachments,application_questions',
    application_id: applicationId
  });
}), withPropsOnChange(['status'], function (_ref4) {
  var status = _ref4.status;
  return {
    reloadRequirements: function reloadRequirements() {
      var _status$requirementsL, _status$requirementsL2;
      status === null || status === void 0 ? void 0 : (_status$requirementsL = status.requirementsList) === null || _status$requirementsL === void 0 ? void 0 : _status$requirementsL.invalidate();
      status === null || status === void 0 ? void 0 : (_status$requirementsL2 = status.requirementsList) === null || _status$requirementsL2 === void 0 ? void 0 : _status$requirementsL2.refetch();
    }
  };
}), branch(function (_ref5) {
  var _status$requirementsL3, _status$requirementsL4;
  var status = _ref5.status,
    isRequirementEvaluationPending = _ref5.isRequirementEvaluationPending;
  return isRequirementEvaluationPending || (status === null || status === void 0 ? void 0 : (_status$requirementsL3 = status.requirementsList) === null || _status$requirementsL3 === void 0 ? void 0 : (_status$requirementsL4 = _status$requirementsL3.meta) === null || _status$requirementsL4 === void 0 ? void 0 : _status$requirementsL4.evaluation_status) === 'pending';
}, renderComponent(ReloadRequirementsMessage)), withPropsOnChange(function (props, nextProps) {
  return props.status.requirementsList.isLoading !== nextProps.status.requirementsList.isLoading;
}, function (_ref6) {
  var status = _ref6.status;
  return {
    loading: status.requirementsList.isLoading,
    className: 'new-reqs-loading'
  };
}), displayLoadingState(), connect(createStructuredSelector({
  applicationRequirements: createApplicationRequirementsSelector()
})), branch(function (_ref7) {
  var _status$requirementsL5, _status$requirementsL6;
  var status = _ref7.status,
    applicationRequirements = _ref7.applicationRequirements;
  var isLoading = status && status.requirementsList && status.requirementsList.isLoading;
  if (isLoading) return false;
  return !(applicationRequirements !== null && applicationRequirements !== void 0 && applicationRequirements.length) && (status === null || status === void 0 ? void 0 : (_status$requirementsL5 = status.requirementsList) === null || _status$requirementsL5 === void 0 ? void 0 : (_status$requirementsL6 = _status$requirementsL5.meta) === null || _status$requirementsL6 === void 0 ? void 0 : _status$requirementsL6.evaluation_status) !== 'pending';
}, renderComponent(EmptyState)), withPropsOnChange(function (_ref8, oldProps) {
  var activeStages = _ref8.activeStages,
    applicationRequirements = _ref8.applicationRequirements,
    tab = _ref8.tab;
  if (!applicationRequirements || applicationRequirements.length <= 0) return false;
  if (!oldProps) return true;
  if (oldProps.tab != tab) return true;
  if (activeStages !== oldProps.activeStages) return true;
  if (applicationRequirements !== oldProps.applicationRequirements) return true;
  return false;
}, function (_ref9) {
  var activeStages = _ref9.activeStages,
    applicationRequirements = _ref9.applicationRequirements,
    userPermissions = _ref9.userPermissions,
    tab = _ref9.tab;
  var userIsAdmin = userPermissions.create_requirement_with_template || userPermissions.create_requirement_without_template;
  // only want to generate all stages for Admin, otherwise we will just use
  // the stages included in the requirements sent from the backend
  var requirementsByStage = !userIsAdmin ? [] : stageOrder.map(function (stage) {
    return {
      stageActive: activeStages.includes(stage),
      stageName: stage,
      requirements: []
    };
  });
  applicationRequirements.forEach(function (req) {
    if (req.attachments) {
      req.attachments = req.attachments.map(function (attachment) {
        var camelizedAttachment = camelizeProperties(attachment);
        camelizedAttachment.automatedVerificationResults = camelizedAttachment.automatedVerificationResults.map(function (verificationResult) {
          var result = camelizeProperties(verificationResult);
          if (result.outcome) {
            result.outcome = result.outcome.map(function (outcome) {
              return camelizeProperties(outcome);
            });
          }
          return result;
        });
        camelizedAttachment.automatedExtractionResults = camelizedAttachment.automatedExtractionResults.map(function (extractionResult) {
          var result = camelizeProperties(extractionResult);
          if (result.content) {
            result.content = result.content.map(function (content) {
              return camelizeProperties(content);
            });
          }
          return result;
        });
        return camelizedAttachment;
      });
    }
    if (isHiddenRequirement(req, userIsAdmin)) return;
    var reqStage = req.current_stage.name;
    var stageFromArray = requirementsByStage.find(function (stg) {
      return stg.stageName === reqStage;
    });
    if (!stageFromArray) {
      if (isInternalRequirement(req) && tab && tab.toLowerCase() === 'actions') {
        requirementsByStage.push({
          stageActive: activeStages.includes(reqStage),
          stageName: reqStage,
          requirements: [req]
        });
      } else if (!isInternalRequirement(req) && !(tab && tab.toLowerCase() === 'actions')) {
        requirementsByStage.push({
          stageActive: activeStages.includes(reqStage),
          stageName: reqStage,
          requirements: [req]
        });
      }
    } else if (isInternalRequirement(req) && tab && tab.toLowerCase() === 'actions') {
      stageFromArray.requirements.push(req);
    } else if (!isInternalRequirement(req) && !(tab && tab.toLowerCase() === 'actions')) {
      stageFromArray.requirements.push(req);
    }
  });

  // for Admin we have stages in order already from the stageOrder
  // otherwise need to sort the stages here
  if (!userIsAdmin) {
    requirementsByStage = sortRequirementsList(requirementsByStage, function (r) {
      return r.stageName;
    });
  }
  requirementsByStage.forEach(function (stage) {
    var required = [];
    var optional = [];
    var inactive = [];
    stage.requirements.forEach(function (req) {
      if (req.required_state === 'required_state_inactive') {
        inactive.push(req);
      } else if (req.required_state === 'required_state_optional') {
        optional.push(req);
      } else {
        required.push(req);
      }
    });
    required.sort(requirementSort);
    optional.sort(requirementSort);
    inactive.sort(requirementSort);
    stage.requirements = [].concat(required, optional, inactive);
  });
  return {
    requirementsByStage: requirementsByStage
  };
}), withStateHandlers({
  conditionModalVisible: false,
  conditionValues: {
    title: '',
    description: '',
    condition_groups: []
  }
}, {
  onToggleConditionModal: function onToggleConditionModal(_ref10) {
    var conditionModalVisible = _ref10.conditionModalVisible;
    return function (conditionObj) {
      return {
        conditionModalVisible: !conditionModalVisible,
        conditionValues: conditionObj
      };
    };
  }
}), withHandlers({
  onChangeRequirementStatus: function onChangeRequirementStatus(_ref11) {
    var updateApplicationRequirementReviewStatus = _ref11.updateApplicationRequirementReviewStatus,
      updateApplicationRequirementApproveStatus = _ref11.updateApplicationRequirementApproveStatus,
      updateApplicationRequirementDisapproveStatus = _ref11.updateApplicationRequirementDisapproveStatus,
      applicationId = _ref11.applicationId;
    return function (requirement_id, next_value) {
      switch (next_value) {
        case 'completed':
          return updateApplicationRequirementApproveStatus(applicationId, requirement_id);
        case 'not_approved':
          return updateApplicationRequirementDisapproveStatus(applicationId, requirement_id);
        case 'reviewing':
          return updateApplicationRequirementReviewStatus(requirement_id);

        // case 'no_status':
        // case 'missing':
        default:
          break;
      }
      return Promise.resolve(true);
    };
  }
}), mapProps(function (_ref12) {
  var onChangeRequirementStatus = _ref12.onChangeRequirementStatus,
    userPermissions = _ref12.userPermissions,
    props = _objectWithoutProperties(_ref12, _excluded);
  var allowed = userPermissions.update_requirement_status;
  if (!allowed) return _objectSpread({
    userPermissions: userPermissions
  }, props);
  return _objectSpread({
    onChangeRequirementStatus: onChangeRequirementStatus,
    userPermissions: userPermissions
  }, props);
}), setPropTypes({
  applicationRequirements: PropTypes.array,
  applicationId: PropTypes.number,
  closeRequirementModal: PropTypes.func,
  onToggleConditionModal: PropTypes.func,
  preview: PropTypes.bool,
  previewRequirement: PropTypes.func,
  requirementsList: PropTypes.array,
  requirementsByStage: PropTypes.array,
  requirementModalVisible: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  setEditingRequirement: PropTypes.func,
  status: PropTypes.object
}));
export default enhancer;